<template>
    <div
        class="form-input-currency"
        :class="{'form-input-currency--error': hasValidationErrors}">

        <label
            v-if="label"
            class="form-input-currency__label">
            {{ label }}
            <span
                v-if="tooltip"
                :data-tippy-content="tooltip"
                class="form-input-currency__tooltip">
                <SvgUse
                    :width="14"
                    :height="14"
                    id="help"
                ></SvgUse>
            </span>
        </label>

        <div class="form-input-currency__wrapper">

            <div class="form-input-currency__icon">
                {{ getCurrencySymbol }}
            </div>

            <input
                type="number"
                :disabled="disabled"
                autocomplete="nope"
                class="form-input-currency__control"
                :placeholder="placeholder"
                :value="modelValue"
                @focusout="onFocusOut"
                @paste.prevent="onPaste"
                @keyup="keyup()"
                @input="updateValue">

            <div
                v-if="disabled"
                class="form-input-currency__locked">
                <SvgUse
                    :width="14"
                    :height="14"
                    id="lock"
                ></SvgUse>
            </div>


        </div>

        <div
            v-if="hasValidationErrors"
            class="form-input-currency__notice">
            <span
                v-for="validation in validations"
                v-show="!validation.rule">
                {{ validation.message }}.
            </span>

        </div>

    </div>
</template>

<script>
module.exports = {
    name: 'FormInputCurrency',
    data() {
        return {
            hasValidationErrors: false
        };
    },
    model: {
        prop: 'modelValue',
        event: 'update'
    },
    props: {
        label: {
            type: [String, Boolean],
            default: 'Label'
        },
        tooltip: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default: ''
        },
        modelValue: {
            default: ''
        },
        disabled: {
            default: false,
            type: Boolean,
        },
        currency: {
            type: String,
            default: 'USD',
            required: true,
        },
        validations: {
            type: Array,
            default() {
                return [];
            }
        },
        type: {
            type: String,
            default: 'text'
        },
    },
    computed: {
        getCurrencySymbol() {
            if (this.currency === 'USD') return '$';
            if (this.currency === 'EUR') return '€';
            if (this.currency === 'RUB') return '₽';
            return '';
        },
    },
    watch: {
        modelValue(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.checkValidationErrors();
            }
        }
    },
    methods: {
        onFocusOut() {
            let value = parseFloat(this.modelValue).toFixed(2);
            this.emitNewValue(value)
        },
        emitNewValue(value) {
            this.$emit('update:modelValue', value);
        },
        updateValue(event, oldVal) {
            this.emitNewValue(event.target.value);
            this.checkValidationErrors();
        },
        keyup() {
            this.checkValidationErrors();
            this.$emit('keyup');
        },
        checkValidationErrors() {
            this.hasValidationErrors = false;
            this.validations.forEach(validation => {
                if (!validation.rule) {
                    this.hasValidationErrors = true;
                }
            });
        },
        disableValidation() {
            console.log('disableValidation()');
            this.hasValidationErrors = false;
        },
        onPaste(event) {
            this.emitNewValue(event.clipboardData.getData('text').trim());
        }
    },
    mounted() {
        WV.Bus.on('fireValidations', this.checkValidationErrors);
        WV.Bus.on('disableValidations', this.disableValidation);
    }
};
</script>

<style lang="scss">

@import '../scss/utils/mixins.scss';
@import '../scss/utils/variables.scss';

.form-input-currency {
    width: 100%;
    padding: 0;
    position: relative;
    height: 50px;
    input[type=number] {
        -moz-appearance: textfield;
    }
    &__label {
        position: absolute;
        z-index: 99;
        bottom: calc(100% - 10px);
        left: 5px;
        padding: 0 5px;
        border-radius: 5px;
        background: white;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        font-family: $font-secondary;
        font-weight: 300;
        font-size: 13px;
        line-height: 120%;
        height: 20px;
        letter-spacing: 0.5px;
        color: $color-text-muted;
    }
    &__tooltip {
        margin-left: 7px;
        height: 14px;
        width: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    &__wrapper {
        position: relative;
        height: 50px
    }
    &__icon {
        font-family: $font-secondary;
        font-size: 15px;
        color: $color-text-default;
        position: absolute;
        height: 50px;
        width: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    &__control {
        width: 100%;
        height: 50px;
        font-family: $font-secondary;
        font-size: 14px;
        line-height: 16px;
        padding-left: 36px;
        border: 1px solid $color-day-line;
        border-radius: 3px;
        letter-spacing: .5px;
        color: $color-text-default;
        &:disabled{
            background-image: linear-gradient(129deg,#fff,#f5f5f5);
        }
        &::-webkit-outer-spin-button,
        &::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }
    }
    &__locked{
        position: absolute;
        right: 15px;
        top: calc(50% - 7px);
        svg{
            fill: $color-text-muted;
        }
    }
    &__notice {
        position: absolute;
        top: 100%;
        min-height: 30px;
        font-size: 12px;
        line-height: 14px;
        font-weight: 400;
        font-family: $font-secondary;
        letter-spacing: 0.02em;
    }
    &--error {
        .form-input-currency__control {
            border: 1px solid $color-day-error-dark;
        }
        .form-input-currency__notice {
            color: $color-day-error-dark;
        }
    }
}
</style>
